/* @flow */
import * as React from 'react';
import BoxBody from 'components/BoxBody';
import BoxHeader from 'components/BoxHeader';
import Group from 'entities/Group';
import Text from 'components/Text';
import CurrentUser from 'auth/CurrentUser';
import UsersSmsInviteInstructionsPhone from 'users/components/UsersSmsInviteInstructionsPhone';

import './styles/SmsInstruction.scss';

type Props = {
  group: Group,
};

class SmsInstruction extends React.Component<Props> {
  render() {
    const { group } = this.props;

    let number;
    if (CurrentUser.isSignedIn()) {
      number =
        !group.useShortCodeForUser(CurrentUser.getUser()) && group.getSMSAlternateNumber()
          ? group.getSMSAlternateNumber()
          : group.getSMSNumber();
    } else {
      number =
        !(group.getSubscriptionInfo().sms && group.hasShortCode()) && group.getSMSAlternateNumber()
          ? group.getSMSAlternateNumber()
          : group.getSMSNumber();
    }
    const code = group.getCode();

    const title = (
      <span>
        Tell people to text @{code} to the number {number}
      </span>
    );

    const alternateNumber = group.getSMSAlternateNumber();

    const subtext = (
      <span>
        They’ll receive a welcome text from Remind.
        {alternateNumber && (
          <Text>
            <br />
            If anyone has trouble with {number}, they can try texting @{code} to {alternateNumber}.
          </Text>
        )}
      </span>
    );
    return (
      <div className="SmsInstruction">
        <BoxHeader title={title} subtext={subtext} />
        <BoxBody>
          <UsersSmsInviteInstructionsPhone
            code={code}
            number={number}
            className="SmsInstruction-phone"
          />
        </BoxBody>
      </div>
    );
  }
}
export default SmsInstruction;
